<template>
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-6">
    <base-card :with-style="withStyle">
      <dt class="text-sm text-gray-700">Jumlah Cash Bill</dt>
      <dd class="mt-1 font-bold text-gray-900">
        {{ meta.count | toCurrency }}
      </dd>
    </base-card>
    <base-card :with-style="withStyle">
      <dt class="text-sm text-gray-700">Total PV</dt>
      <dd class="mt-1 font-bold text-gray-900">
        {{ meta.totalPv | toCurrency }}
      </dd>
    </base-card>
    <base-card :with-style="withStyle">
      <dt class="text-sm text-gray-700">Total BV</dt>
      <dd class="mt-1 font-bold text-gray-900">
        {{ meta.totalBv | toCurrency }}
      </dd>
    </base-card>
    <base-card :with-style="withStyle">
      <dt class="text-sm text-gray-700">Total Harga</dt>
      <dd class="mt-1 font-bold text-gray-900">
        {{ meta.totalPrice | toCurrency }}
      </dd>
    </base-card>
    <base-card :with-style="withStyle" v-if="withOmzet">
      <dt class="text-sm text-gray-700">Omzet</dt>
      <dd class="mt-1 font-bold text-gray-900">
        {{ meta.totalOmzet | toCurrency }}
      </dd>
    </base-card>
  </div>
</template>

<script>
export default {
  props: {
    meta: Object,
    withOmzet: Boolean,
    withStyle: {
      type: Boolean,
      default: true
    }
  },
};
</script>
